import React, { Fragment, useEffect, useState } from "react";
import AddBoxIcon from "@mui/icons-material/AddBox";
import { useNavigate, useOutletContext } from "react-router-dom";
import {
  deleteEmployeeService,
  fetchEmployeeService,
} from "../../services/employeeService";
import { updateEmployeeStatusService } from "../../services/employeeService";
import { EMPLOYEE_STATUS_TYPE } from "../../constants/enums";
import {
  Card,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TablePagination,
  Checkbox,
  OutlinedInput,
  InputAdornment,
  IconButton,
  Dialog,
  // Tooltip,
} from "@mui/material";
import { Tooltip } from "antd";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import {
  checkPermissions,
  checkSubscriptionPermission,
  toastMessage,
} from "../../helper";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import EmptyList from "../common/EmptyList";
import { MODE } from "../../constants/enums";
import EmployeeDetailedView from "./EmployeeDetailedView";
import { useSelector } from "react-redux";
import SubscriptionUpgrade from "../Subscription/SubscriptionUpgrade";
import UpgradeMessageDialog from "../Subscription/UpgradeMessageDialog";
import EmissionStatusFilter from "../EmissionLog/EmissionApprovalManagement/EmissionStatusFilter";
import TableFilterSort from "../common/TableFilterSort";
import SkeletonLoader from "../common/Skeletons/TableSkeleton/TableSkeletonLoader";
import { fetchUser } from "../../services/orgService";
import ConfirmationDialog from "../common/ConfirmationDialog";
import { fetchEmployeesCount } from "../../services/userService";
const EmployeeList = () => {
  const permissions = useSelector((state: any) => state.auth.userPermissions);
  const plansPermissions = useSelector(
    (state: any) => state.sub.subscriptionPermissions
  );
  const addonPermissions = useSelector(
    (state: any) => state.sub.addonPermissions
  );
  const companyPreferences = useSelector(
    (state: any) => state.org.companyPreferences
  );
  const [employeeList, setEmployeeList] = useState([] as any);
  const [mode, setMode] = useState(MODE.PLAIN);
  const [selectedCount, setSelectedCount] = useState(0);
  const [dialCode, setDialCode] = useState();
  const [isAdminSelected, setIsAdminSelected] = useState(false);
  const [isAllStudentsSelectedInactive, setIsAllStudentsSelectedInactive] =
    useState(false);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [detailedSelectIndex, setDetailedSelectIndex] = useState(0);
  const [linkedBunits, setLinkedBunits] = useState([]);
  const [detailedSelectItem, setDetailedSelectItem] = useState({} as any);
  const [searchText, setSearchText] = useState("");
  const [state, dispatch]: any = useOutletContext();
  const [isLoading, setIsLoading] = useState(true);
  // Name  Incharge, Unit type ,Address ,Status ,Unit ID

  let cellColumns = [
    " ",
    "Name",
    "Employee Code",
    "System Role",
    "Designation",
    "Email",
    "Status",
  ];
  const [employeeCount, setEmployeeCount] = useState(0);
  const [controller, setController] = useState<any>({
    page: 0,
    limit: 10,
    sortBy: null,
    sortOrder: null,
    filters: {},
    columns: {
      Name: {
        type: "string",
        hasSortBy: true,
        filterOptions: {},
      },
      "Employee Code": {
        type: "string",
        hasSortBy: true,
        filterOptions: {},
      },
      "System Role": {
        type: "number",
        hasSortBy: false,
        filterOptions: {
          "Super User": {
            value: 1,
            selected: false,
          },
          Manager: {
            value: 2,
            selected: false,
          },
          "Business User": {
            value: 3,
            selected: false,
          },
          Verifier: {
            value: 4,
            selected: false,
          },
        },
        filterName: "roles",
      },
      Designation: {
        type: "string",
        hasSortBy: true,
        filterOptions: {},
      },
      Email: {
        type: "string",
        hasSortBy: true,
        filterOptions: {},
      },
      Status: {
        type: "string",
        hasSortBy: false,
        isLastColumn: true,
        filterOptions: {
          "Request Sent": {
            value: "Request Sent",
            selected: false,
          },
          Active: {
            value: "Active",
            selected: false,
          },
          InActive: {
            value: "InActive",
            selected: false,
          },
        },
      },
    },
  });
  const [openTableFilterSort, setOpenTableFilterSort] = useState(false);
  const [selectedColumnData, setSelectedColumnData] = useState<any>();
  const showEmployeeFilterOptions = (columnName: any) => {
    if (columnName in controller.columns) {
      let selectedColumnData = controller.columns[columnName];
      if (
        selectedColumnData.hasSortBy &&
        Object.keys(selectedColumnData?.filterOptions)?.length === 0
      ) {
        const filterController: any = {
          sortBy: columnName,
        };
        if (controller.sortBy === columnName) {
          filterController["sortOrder"] =
            controller.sortOrder === "ASC" ? "DESC" : "ASC";
        } else {
          filterController["sortOrder"] = "ASC";
        }
        handleFilterAndSort(filterController, true);
      } else {
        selectedColumnData["columnName"] = columnName;
        selectedColumnData["sortBy"] = controller.sortBy;
        selectedColumnData["sortOrder"] = controller.sortOrder;
        setSelectedColumnData(selectedColumnData);
        setOpenTableFilterSort(true);
      }
    }
  };
  const handleFilterAndSort = (filterController: any, directSort: boolean) => {
    const updatedController = {
      ...controller,
      page: 0,
    };
    if (filterController.sortBy && filterController.sortOrder) {
      updatedController.sortBy = filterController.sortBy;
      updatedController.sortOrder = filterController.sortOrder;
    }
    if (filterController.selectedFilters?.length) {
      updatedController.filters[selectedColumnData.columnName] =
        filterController.selectedFilters;
    } else if (
      !directSort &&
      selectedColumnData &&
      updatedController.filters[selectedColumnData.columnName]
    ) {
      delete updatedController.filters[selectedColumnData.columnName];
    }
    setController({ ...updatedController });
    setOpenTableFilterSort(false);
  };

  const [openDialog, setOpenDialog] = useState(false);
  const handleClose = () => {
    setOpenDialog(false);
  };
  const handleAddNewEmployee = () => {
    fetchEmployeesCount().then((res) => {
      if (
        res?.data &&
        companyPreferences?.account_type?.length &&
        checkSubscriptionPermission(
          "USER",
          plansPermissions,
          companyPreferences?.account_type === "TRAINER"
            ? res.data.count_including_deleted
            : res.data.active_count,
          addonPermissions
        )
      ) {
        addNewEmployee();
      } else {
        setOpenDialog(true);
      }
    });
  };
  const navigate = useNavigate();
  const addNewEmployee = () => {
    navigate("/organisation/employee/add-employee");
    dispatch({ type: "clearDetailview" });
  };
  const onChangeSelected = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    let empList: any = employeeList;
    empList[index]["selected"] = e.target.checked;
    setIsAdminSelected(
      empList?.find((each: any) => each.role_name === "Admin")?.selected
    );
    const selectedCount =
      empList.filter((eachUnit: any) => eachUnit.selected)?.length || 0;
    setSelectedCount(selectedCount);
    const allInactiveStudentsSelected =
      selectedCount &&
      empList.filter(
        (eachSelectedUser: any) =>
          eachSelectedUser.user_disabled &&
          eachSelectedUser.role_name === "Student"
      ).length === selectedCount;
    setIsAllStudentsSelectedInactive(!!allInactiveStudentsSelected);
    setEmployeeList([...empList]);
    e.stopPropagation();
  };

  const handlePageChange = (event: any, newPage: number) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event: any) => {
    setController({
      ...controller,
      limit: parseInt(event.target.value, 10),
      page: 0,
    });
  };
  const onSelectBunit = (e: any, index: number) => {
    const selectedEmployee = getSelectedEmployeeData(index);
    selectedEmployee?.userId &&
      fetchUser(selectedEmployee.userId).then((res) => {
        const units = res.data?.users?.units?.length
          ? res.data.users.units
          : [];
        setMode(MODE.SELECTED);
        setDetailedSelectIndex(index);
        setLinkedBunits(getSelectedBunitsData(index, units));
        setDetailedSelectItem(selectedEmployee);
      });
  };
  const onClose = () => {
    setMode(MODE.PLAIN);
  };
  const handleCancel = () => {
    let empList: any = employeeList;
    empList.forEach((element: any) => {
      element["selected"] = false;
    });
    setEmployeeList([...empList]);
    setSelectedCount(0);
  };

  const getSelectedEmployeeData = (index: any) => {
    const {
      email,
      department,
      employee_code,
      role_name,
      mobile,
      display_name,
      designation,
      profile_image_url,
      user,
      status,
      address_line1,
      city,
      city_code,
      state,
      state_code,
      country,
      country_code,
      user_disabled,
    } = employeeList[index];
    const address = employeeList[index].address_line1;
    const dialCode = employeeList[index].dialcode;
    setDialCode(dialCode);
    // const mobile = employeeList[index].mobile?.length > 0 ? dialCode + employeeList[index].mobile : '';
    return {
      email,
      department,
      employee_code,
      designation,
      mobile,
      address,
      dialCode,
      role_name,
      display_name,
      profile_image_url,
      userId: user,
      status,
      address_line1,
      city,
      city_code,
      state,
      state_code,
      country,
      country_code,
      user_disabled,
    };
  };
  const getSelectedBunitsData = (index: any, units: any[]) => {
    const unitsRes = employeeList[index].units.map((eachUnit: any) => {
      const unitDetailsIndex = units.findIndex(
        (eachUnitDetails: any) => eachUnitDetails.id === eachUnit.business_unit
      );
      if (unitDetailsIndex > -1) {
        return {
          ...eachUnit,
          business_name: units[unitDetailsIndex].name,
          business_type: units[unitDetailsIndex].typeName,
          business_id: units[unitDetailsIndex].registrationId,
          business_incharge: units[unitDetailsIndex].inchargeName,
        };
      } else {
        return eachUnit;
      }
    });
    return unitsRes;
  };

  const navigateNext = (increment: number, pageIncrement: number) => {
    if (pageIncrement) {
      setController((prevState: any) => {
        return { ...prevState, page: prevState.page + pageIncrement };
      });
      setDetailedSelectIndex(() =>
        pageIncrement === -1 ? controller.limit - 1 : 0
      );
    } else if (increment) {
      const selectedEmployee = getSelectedEmployeeData(
        detailedSelectIndex + increment
      );
      selectedEmployee?.userId &&
        fetchUser(selectedEmployee.userId).then((res) => {
          const units = res.data?.users?.units?.length
            ? res.data.users.units
            : [];
          setLinkedBunits(
            getSelectedBunitsData(detailedSelectIndex + increment, units)
          );
          setDetailedSelectItem(selectedEmployee);
          setDetailedSelectIndex((prevIndex) => prevIndex + increment);
        });
    }
  };

  const handleEmployeeSearch = (type?: any) => {
    let callType = "search";
    if (type && type === "cancel") {
      setSearchText("");
      callType = type;
    }
    getEmployeeData(type);
  };

  const getEmployeeData = (type?: any) => {
    const employeeObject: any = {
      searchText: type === "cancel" ? "" : searchText,
      controller,
      filter: {},
    };
    console.log(controller?.filters);
    if (Object.keys(controller?.filters).length > 0) {
      Object.entries(controller?.filters).forEach(
        ([filterKey, filterValues]: any) => {
          if (filterValues.length) {
            const filterName =
              controller.columns[filterKey]?.filterName || filterKey;
            if (filterName === "Status") {
              const includesActive = filterValues.includes("Active");
              const includesInactive = filterValues.includes("InActive");
              const includesRequestSent = filterValues.includes("Request Sent");
              console.log(
                includesActive,
                includesInactive,
                includesRequestSent
              );
              if (includesActive && !includesInactive && !includesRequestSent) {
                employeeObject.filter["disabled"] = false;
                employeeObject.filter["status"] = "Verified";
              } else if (
                !includesActive &&
                includesInactive &&
                !includesRequestSent
              ) {
                employeeObject.filter["disabled"] = true;
              } else if (
                !includesActive &&
                !includesInactive &&
                includesRequestSent
              ) {
                employeeObject.filter["disabled"] = false;
                employeeObject.filter["status"] = "RegisterRequest";
              } else if (
                includesActive &&
                includesInactive &&
                !includesRequestSent
              ) {
                employeeObject.filter["status"] = "Verified";
              } else if (
                includesActive &&
                !includesInactive &&
                includesRequestSent
              ) {
                employeeObject.filter["disabled"] = false;
              } else if (
                !includesActive &&
                includesInactive &&
                includesRequestSent
              ) {
                employeeObject.filter["statusNegation"] = false;
                employeeObject.filter["disabled"] = false;
                employeeObject.filter["status"] = "RegisterRequest";
              }
            } else if (filterName === "roles") {
              const tempFilterVal = filterValues.map((eachValue: string) =>
                eachValue === "Super User" ? "Admin" : eachValue
              );
              let filterValueString: string = tempFilterVal?.join(",");
              employeeObject.filter[filterName] = filterValueString;
            } else {
              let filterValuesString: string = filterValues?.join(",");
              employeeObject.filter[filterName] = filterValuesString;
            }
          }
        }
      );
    }
    setIsLoading(true);
    fetchEmployeeService(employeeObject)
      .then((res) => {
        if (res?.data) {
          const employeeList = res.data.users;
          employeeList.map((eachEmp: any) => (eachEmp.selected = false));
          setEmployeeList(employeeList);
          setEmployeeCount(res.data.total_count);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("No record");
      });
  };
  const handleStatusAction = (type: any) => {
    let company =
      localStorage.getItem("company") &&
      JSON.parse(localStorage.getItem("company") || "").id;
    const userIds =
      employeeList
        .filter((each: any) => each.selected)
        .map((eachSelected: any) => eachSelected.user) || [];
    const reqData = {
      company,
      disabled: type === "active" ? false : true,
      userIds,
    };
    updateEmployeeStatusService(reqData)
      .then((res) => {
        console.log(res);
        if (res.status === 200 || res.statusText === "OK") {
          getEmployeeData();
        }
      })
      .catch((e) => {
        console.log(e);
      });
    handleCancel();
  };

  const handleDeleteAction = (confirm: boolean) => {
    if (!confirm) {
      setShowConfirmationDialog(true);
      return;
    }
    setShowConfirmationDialog(false);
    const userIds =
      employeeList
        .filter((each: any) => each.selected)
        .map((eachSelected: any) => eachSelected.user) || [];
    const reqData = {
      userIds,
    };
    deleteEmployeeService(reqData)
      .then((res) => {
        if (res.status === 200 || res.statusText === "OK") {
          getEmployeeData();
        }
      })
      .catch((e) => {
        console.log(e);
      });
    handleCancel();
  };

  const handleEdit = () => {
    const selectedIndexData: any = employeeList.filter(
      (each: any) => each?.selected
    );
    if (selectedIndexData && selectedIndexData?.length === 1) {
      const userData = {
        name: selectedIndexData[0]?.display_name,
        email: selectedIndexData[0]?.email,
        phone: selectedIndexData[0]?.mobile,
        department: {
          value: selectedIndexData[0]?.department,
          label: selectedIndexData[0]?.department,
        },
        designation: selectedIndexData[0]?.designation,
        address: {
          addressLine1: selectedIndexData[0]?.address_line1,
          addressLine2: "",
          city: selectedIndexData[0]?.city,
          cityCode: selectedIndexData[0]?.city_code,
          state: selectedIndexData[0]?.state,
          stateCode: selectedIndexData[0]?.state_code,
          country: selectedIndexData[0]?.country,
          countryCode: selectedIndexData[0]?.country_code,
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
        employeeCode: selectedIndexData[0]?.employee_code,
        profileImageUrl: selectedIndexData[0]?.profile_image_url,
        roleName: selectedIndexData[0]?.role_name,
        userId: selectedIndexData[0]?.user,
        dialCode: selectedIndexData[0].dialcode,
      };
      const linkedBunitData = selectedIndexData[0]?.units?.map((each: any) => {
        return {
          ...each,
          value: each.business_unit,
          label: each.business_name,
        };
      });
      dispatch({
        type: "employeeDetailView",
        data: {
          userData: userData,
          linkedBunit: [...linkedBunitData],
          isEdit: true,
        },
      });
      navigate("/organisation/employee/edit-employee/" + userData.userId, {
        state: {
          userId: userData.userId,
        },
      });
    }
  };
  useEffect(() => {
    getEmployeeData();
  }, [controller, searchText]);

  return (
    <Fragment>
      {!employeeList?.length &&
        searchText === "" &&
        !isLoading &&
        !Object.keys(controller.filters).length && (
          <div className="pw-empty-page flex flex-col h-100v  w-full justify-center items-center gap-5">
            <img
              className="pw-no-items"
              src="assets/images/empty.png"
              alt=" "
            />
            <div>Welcome to Employees</div>
            <div className="pw-bunit-desc">
              Organize and manage your company's employees and role access
            </div>
            {checkPermissions(["CREATE_EMPLOYEE"], permissions) ? (
              <div className="pw-add-new-bunit" onClick={handleAddNewEmployee}>
                <AddBoxIcon className="pw-box-icon" /> <span>New</span>
              </div>
            ) : (
              ""
            )}
          </div>
        )}

      {(employeeList?.length ||
        searchText !== "" ||
        isLoading ||
        Object.keys(controller.filters).length) &&
      mode === MODE.PLAIN ? (
        <div className="pw-blist-main overflow-y-auto  h-full  w-full">
          <div className="pw-blist-header w-full flex flex-row justify-between">
            {/* <FormControl  }} variant="outlined"> */}
            {/* <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel> */}
            <OutlinedInput
              id="outlined-adornment-password "
              className="pw-search-field"
              placeholder="Search"
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleEmployeeSearch("search");
                }
              }}
              endAdornment={
                <InputAdornment position="end">
                  {searchText === "" ? (
                    <IconButton
                      onClick={() => handleEmployeeSearch("cancel")}
                      edge="end"
                    >
                      <SearchIcon />
                    </IconButton>
                  ) : (
                    <IconButton
                      onClick={() => handleEmployeeSearch("cancel")}
                      edge="end"
                    >
                      <CloseIcon />
                    </IconButton>
                  )}
                </InputAdornment>
              }
            />
            {selectedCount === 0 ? (
              <>
                {checkPermissions(["CREATE_EMPLOYEE"], permissions) ? (
                  <div
                    className="pw-add-new-bunit"
                    id="pw-e2e-addemployeebtn"
                    onClick={handleAddNewEmployee}
                  >
                    <AddBoxIcon className="pw-box-icon" /> <span>New</span>
                  </div>
                ) : (
                  ""
                )}
              </>
            ) : (
              <div className="flex flex-row justify-end  gap-4 text-sm">
                <div
                  className="pw-bunit-button-light pw-bunit-button-next bg-white "
                  onClick={handleCancel}
                >
                  Cancel
                </div>
                {checkPermissions(["UPDATE_EMPLOYEE_STATUS"], permissions) &&
                  !isAdminSelected && (
                    <Fragment>
                      <div
                        className="pw-bunit-button-light pw-bunit-button-next bg-white p-2"
                        onClick={() =>
                          handleStatusAction(EMPLOYEE_STATUS_TYPE.ACTIVE)
                        }
                      >
                        Mark as Active
                      </div>
                      <div
                        className="pw-bunit-button-light pw-bunit-button-next bg-white p-2"
                        onClick={() =>
                          handleStatusAction(EMPLOYEE_STATUS_TYPE.INACTIVE)
                        }
                      >
                        Mark as Inactive
                      </div>
                    </Fragment>
                  )}
                {checkPermissions(["UPDATE_EMPLOYEE_STATUS"], permissions) &&
                  !isAdminSelected &&
                  isAllStudentsSelectedInactive && (
                    <Fragment>
                      <div
                        className="pw-bunit-button-light pw-bunit-button-next bg-white p-2"
                        onClick={() => handleDeleteAction(false)}
                      >
                        Delete
                      </div>
                    </Fragment>
                  )}
                {/* <div className="pw-bunit-button-light pw-bunit-button-next bg-white pw-text-color px-2">
                  Mark as Inactive
                </div>
                <div className="pw-bunit-button-light pw-bunit-button-next bg-white pw-text-color px-2">
                  Mark as Active
                </div> */}
                {selectedCount === 1 ? (
                  <Fragment>
                    {/* <div
                      className="pw-bunit-button-light pw-bunit-button-next bg-white"
                      onClick={() =>
                        navigate("/organisation/add-employee/", {
                          state: {
                            id: employeeList?.find(
                              (eachUnit: any) => eachUnit.selected
                            )?.id,
                            isClone: true,
                          },
                        })
                      }
                    >
                      Clone
                    </div> */}
                    <div
                      className="pw-bunit-button-light pw-bunit-button-next bg-white"
                      onClick={handleEdit}
                    >
                      Edit
                    </div>
                  </Fragment>
                ) : (
                  ""
                )}
              </div>
            )}
          </div>
          {isLoading ? (
            <SkeletonLoader type="text" cells={cellColumns} />
          ) : (
            <Fragment>
              {employeeList?.length ||
              Object.keys(controller.filters).length ? (
                <div className="h-70v pw-hide-scroll overflow-y-auto">
                  <Card className="pw-employee-list-container">
                    <Table size="small">
                      <TableHead>
                        <TableRow className="h-14">
                          <TableCell className="bg-neutral-50"></TableCell>

                          {cellColumns.map((eachCell: any, index) => (
                            <TableCell
                              key={index}
                              className={`bg-neutral-50 ${
                                controller.sortBy === eachCell ||
                                (controller.filters[eachCell] &&
                                  Object.keys(controller.filters[eachCell])
                                    ?.length)
                                  ? "!bg-neutral-200 cursor-pointer"
                                  : controller?.columns?.[eachCell] &&
                                    employeeList?.length
                                  ? "pw-head-user-bg cursor-pointer"
                                  : ""
                              } pw-thead-list`}
                              id={eachCell + "-th"}
                              onClick={() => {
                                return employeeList?.length
                                  ? showEmployeeFilterOptions(eachCell)
                                  : Object.keys(controller.filters[eachCell])
                                      ?.length
                                  ? showEmployeeFilterOptions(eachCell)
                                  : "";
                              }}
                            >
                              <div className="flex flex-row items-center gap-1">
                                {
                                  <Tooltip
                                    title={`${
                                      employeeList?.length
                                        ? controller?.columns?.[eachCell] &&
                                          Object.keys(
                                            controller?.columns?.[eachCell]
                                              ?.filterOptions
                                          )?.length
                                          ? "Filter by " + eachCell
                                          : controller?.columns?.[eachCell]
                                              ?.hasSortBy
                                          ? "Sort by " + eachCell
                                          : ""
                                        : ""
                                    }`}
                                    arrow={false}
                                    placement="bottomLeft"
                                  >
                                    <div>{eachCell}</div>
                                  </Tooltip>
                                }

                                {eachCell != " " &&
                                  controller.sortBy === eachCell &&
                                  // <img
                                  //   src={
                                  //     controller.sortOrder === "ASC"
                                  //       ? "assets/icons/sort_alphabetical_ascending.svg"
                                  //       : "assets/icons/sort_alphabetical_descending.svg"
                                  //   }
                                  //   alt=""
                                  // />
                                  (controller.sortOrder === "ASC" ? (
                                    <Tooltip
                                      title={`${
                                        employeeList?.length
                                          ? "Ascending Order - Click to sort in descending order"
                                          : ""
                                      }`}
                                      placement="bottomLeft"
                                      arrow={false}
                                    >
                                      <ArrowUpwardIcon sx={{ fontSize: 16 }} />
                                    </Tooltip>
                                  ) : (
                                    <Tooltip
                                      title="Descending Order - Click to sort in ascending order"
                                      placement="bottomLeft"
                                      arrow={false}
                                    >
                                      <ArrowDownwardIcon
                                        sx={{ fontSize: 16 }}
                                      />
                                    </Tooltip>
                                  ))}
                                {controller?.columns?.[eachCell] &&
                                Object.keys(
                                  controller?.columns?.[eachCell]?.filterOptions
                                )?.length ? (
                                  <img
                                    src="assets/icons/filter-variant.svg"
                                    alt=""
                                  />
                                ) : (
                                  ""
                                )}
                              </div>
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      {employeeList?.length ? (
                        <TableBody className="cursor-pointer">
                          {employeeList.map(
                            (eachEmployee: any, index: number) => (
                              <TableRow
                                key={eachEmployee.id}
                                onClick={(e) => onSelectBunit(e, index)}
                                className={` ${
                                  eachEmployee.selected
                                    ? "bg-primary-100"
                                    : "bg-white"
                                } h-14`}
                                id={
                                  eachEmployee.email
                                    ? `pw-e2e-${eachEmployee.email.replace(
                                        /[@.]/g,
                                        ""
                                      )}`
                                    : ""
                                }
                              >
                                <TableCell className="pw-bunit-padding pw-bunit-width">
                                  {checkPermissions(
                                    ["UPDATE_EMPLOYEE"],
                                    permissions
                                  ) ? (
                                    <Checkbox
                                      checked={eachEmployee.selected}
                                      onClick={(e: any) =>
                                        onChangeSelected(e, index)
                                      }
                                    />
                                  ) : (
                                    ""
                                  )}
                                </TableCell>
                                <TableCell className="pw-bunit-padding pw-bunit-image-width">
                                  <img
                                    src={
                                      eachEmployee.profile_image_url
                                        ? eachEmployee.profile_image_url
                                        : "assets/icons/account.svg"
                                    }
                                    alt=" "
                                    className="h-9 pw-bunit-list-image"
                                  />
                                </TableCell>

                                <TableCell>
                                  {" "}
                                  {eachEmployee.display_name}{" "}
                                </TableCell>
                                <TableCell>
                                  {" "}
                                  {eachEmployee.employee_code || "-"}{" "}
                                </TableCell>
                                <TableCell>
                                  {" "}
                                  {eachEmployee.role_name === "Admin"
                                    ? "Super user"
                                    : eachEmployee.role_name}{" "}
                                </TableCell>
                                {/* <TableCell> {eachBUnit.address || "-"} </TableCell> */}
                                <TableCell>
                                  {" "}
                                  <span>
                                    {eachEmployee.designation || "-"}
                                  </span>{" "}
                                </TableCell>
                                <TableCell>
                                  {" "}
                                  {eachEmployee.email || "-"}{" "}
                                </TableCell>
                                <TableCell>
                                  {eachEmployee.user_disabled ? (
                                    <span
                                      className="pw-inactive-employee"
                                      id="pw-e2e-employee-status"
                                    >
                                      InActive
                                    </span>
                                  ) : eachEmployee.status ===
                                    "RegisterRequest" ? (
                                    "Request Sent"
                                  ) : (
                                    <span className="pw-active-employee">
                                      Active
                                    </span>
                                  )}
                                </TableCell>
                              </TableRow>
                            )
                          )}
                        </TableBody>
                      ) : (
                        " "
                      )}
                    </Table>
                  </Card>
                  {!employeeList?.length ? (
                    <div className="flex justify-center items-center h-full bg-white">
                      No results found
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                <EmptyList cellColumns={cellColumns} />
              )}
              {employeeCount >= 10 && (
                <TablePagination
                  component="div"
                  onPageChange={handlePageChange}
                  page={controller.page}
                  count={employeeCount}
                  rowsPerPage={controller.limit}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              )}
            </Fragment>
          )}
        </div>
      ) : (
        ""
      )}

      {(employeeList?.length || searchText !== "") && mode === MODE.SELECTED ? (
        <div className="pw-blist-main-selected w-full  h-90v flex flex-row">
          <div className="flex flex-col w-1/3 bg-neutral-200 pw-width-side">
            <div className="h-full pw-select-side-list overflow-y-auto flex flex-col w-45 gap-px">
              <div className="flex flex-row justify-between pw-padding-side-2 gap-4">
                <OutlinedInput
                  id="outlined-adornment-password "
                  className="pw-search-field pw-search-field-2"
                  placeholder="Search"
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(() => e.target.value);
                  }}
                  endAdornment={
                    <InputAdornment position="end">
                      {searchText === "" ? (
                        <IconButton edge="end">
                          <SearchIcon />
                        </IconButton>
                      ) : (
                        <IconButton edge="end">
                          <CloseIcon />
                        </IconButton>
                      )}
                    </InputAdornment>
                  }
                />
                {checkPermissions(["CREATE_EMPLOYEE"], permissions) ? (
                  <div
                    className="pw-add-new-bunit"
                    onClick={handleAddNewEmployee}
                  >
                    <AddBoxIcon className="pw-box-icon" /> <span>New</span>
                  </div>
                ) : (
                  ""
                )}
              </div>

              {employeeList?.length ? (
                employeeList.map((eachEmployee: any, index: number) => (
                  <div
                    className={`flex flex-row cursor-pointer pw-bunitlist-card ${
                      detailedSelectItem?.userId === eachEmployee.user
                        ? "bg-neutral-100"
                        : "bg-white"
                    }`}
                    key={eachEmployee.id}
                    onClick={(e) => onSelectBunit(e, index)}
                  >
                    <div className="flex items-center">
                      <img
                        src={
                          eachEmployee.profile_image_url
                            ? eachEmployee.profile_image_url
                            : "assets/icons/account.svg"
                        }
                        alt=" "
                        className="h-9 pw-bunit-list-image"
                      />
                    </div>
                    <div className="flex flex-col justify-center">
                      <div className="pw-bunit-name font-medium text-sm ">
                        {eachEmployee.display_name}
                      </div>
                      <div className="pw-bunit-incharge text-neutral-600 text-sm">
                        {eachEmployee.designation}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <EmptyList />
              )}
            </div>

            {employeeCount >= 10 ? (
              <TablePagination
                component="div"
                count={employeeCount}
                page={controller.page}
                colSpan={5}
                onPageChange={handlePageChange}
                rowsPerPage={controller.limit}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage=""
                className="flex flex-row justify-end"
              />
            ) : (
              ""
            )}
          </div>
          {employeeList?.length ? (
            <EmployeeDetailedView
              state={state}
              dispatch={dispatch}
              dialCode={dialCode}
              employeeData={detailedSelectItem}
              linkedBunits={linkedBunits}
              currentIndex={detailedSelectIndex}
              controller={controller}
              total_count={employeeCount}
              navigateNext={navigateNext}
              setController={setController}
              onClose={onClose}
            />
          ) : (
            <EmptyList detailedView={true} />
          )}
        </div>
      ) : (
        ""
      )}
      {openDialog && (
        <UpgradeMessageDialog
          open={openDialog}
          onClose={handleClose}
          limit={employeeCount}
          limitType={employeeCount === 1 ? "employee" : "employees"}
        />
      )}
      {openTableFilterSort && (
        <TableFilterSort
          selectedColumnData={selectedColumnData}
          openTableFilterSort={openTableFilterSort}
          setOpenTableFilterSort={setOpenTableFilterSort}
          handleFilterAndSort={handleFilterAndSort}
          filter={controller.filters}
        />
      )}
      {showConfirmationDialog && (
        <ConfirmationDialog
          open={showConfirmationDialog}
          onClose={() => setShowConfirmationDialog(false)}
          onConfirm={() => handleDeleteAction(true)}
          headerText={"Delete selected employees"}
          description={
            "Are you sure you want to delete the selected employees? This action is irreversible. Please click on 'Proceed' to confirm the action."
          }
        />
      )}
    </Fragment>
  );
};

export default EmployeeList;
